var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { staticClass: "bg-white ", attrs: { show: _vm.loading } },
    [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("div", { staticClass: "col-12 mt-3" }, [
            _vm._v(
              " ¿Estás seguro de que quieres aprobar " +
                _vm._s(_vm.batches.length) +
                " lotes? "
            )
          ]),
          _c("vs-divider"),
          _c(
            "b-col",
            { staticClass: "text-right", attrs: { cols: "12" } },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "ripple",
                      rawName: "v-ripple.400",
                      value: "rgba(255, 255, 255, 0.15)",
                      expression: "'rgba(255, 255, 255, 0.15)'",
                      modifiers: { "400": true }
                    }
                  ],
                  attrs: {
                    type: "submit",
                    variant: "primary",
                    "data-cy": "cancel-batch"
                  },
                  on: { click: _vm.onApprove }
                },
                [_vm._v(" Si, Estoy seguro! ")]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }